/**
 * React component for rendering a list of quick links.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data for rendering the quick links.
 * @param {boolean} [props.openInNewTab=false] - Flag indicating whether links should open in a new tab.
 * @returns {JSX.Element} The rendered QuickLinks component.
 */

import React, { useEffect, useState } from "react";
import styles from "./StayUpdatedSection.module.scss";
import commonstyles from "../../../common/commonstyles.module.scss";
import Link from "next/link";

const QuickLinks = ({ data, openInNewTab=false }) => {
  return (
    <ul
      className={`text-white gap-[32px] flex flex-col justify-center items-center py-[38px]`}
    >
      <li>
        <Link
          href="/product#faq"
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="FAQ"
          target={openInNewTab ? '_blank' : '_self'}
        >
          {data?.frequentlyAskedQuestionsText}
        </Link>
      </li>
      <li>
        <Link
          href="https://support.maticrobots.com/"
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="Support"
          target={openInNewTab ? '_blank' : '_self'}
        >
          {data?.supportText}
        </Link>
      </li>
      <li>
        <Link
          href="/careers"
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="Careers"
          target={openInNewTab ? '_blank' : '_self'}
        >
          {data?.careersText}
        </Link>
      </li>
      <li>
        <button
          onClick={() => {
            const baseURL = '/blog/';
            const target = openInNewTab ? '_blank' : '_self';
            window.open(baseURL, target);
          }}
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="Blog"
        >
          {data?.blogText}
        </button>
      </li>
      <li>
        <Link
          href="/press"
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="Press"
          target={openInNewTab ? '_blank' : '_self'}
        >
          {data?.pressText}
        </Link>
      </li>
      <li>
        <Link
          href="mailto:hello@maticrobots.com"
          className={`${commonstyles.mg_normal_24} underline-offset-4 hover:underline`}
          title="Contact"
        >
          {data?.contactText}
        </Link>
      </li>
    </ul>
  );
};

export default QuickLinks;
